import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { getSupplierRecording } from '../../api/requests'

interface Props {
    supplierId: number
    filename: string
}

const AudioPlayer: React.FC<Props> = ({ supplierId, filename }) => {
    const [audioUrl, setAudioUrl] = useState<string | null>(null)

    const handlePlay = async () => {
        try {
            if (audioUrl) return

            const response = await getSupplierRecording(supplierId, filename)
            const blob = response.data as Blob

            if (blob.type && blob.type.includes('application/json')) {
                const text = await blob.text()
                const data = JSON.parse(text)
                if (data && data.url) {
                    setAudioUrl(data.url)
                } else {
                    throw new Error('JSON response missing url')
                }
            } else {
                const url = URL.createObjectURL(blob)
                setAudioUrl(url)
            }
        } catch (err) {
            console.error('AudioPlayer handlePlay error:', err)
            toast.error('Failed to play MP3 file', { autoClose: false })
        }
    }

    const handleStop = () => {
        if (audioUrl && audioUrl.startsWith('blob:')) {
            try {
                URL.revokeObjectURL(audioUrl)
            } catch {}
        }
        setAudioUrl(null)
    }

    useEffect(() => {
        return () => {
            if (audioUrl && audioUrl.startsWith('blob:')) {
                try {
                    URL.revokeObjectURL(audioUrl)
                } catch {}
            }
        }
    }, [audioUrl])

    return (
        <div>
            <div className="d-flex gap-2 mt-3">
                <button className="btn btn-success btn-sm" onClick={handlePlay}>
                    ▶ Play
                </button>
                {audioUrl && (
                    <button className="btn btn-outline-danger btn-sm" onClick={handleStop}>
                        ⏹ Stop
                    </button>
                )}
            </div>

            {audioUrl && (
                <audio
                    controls
                    autoPlay
                    src={audioUrl}
                    style={{ marginTop: '10px', width: '100%' }}
                />
            )}
        </div>
    )
}

export default AudioPlayer
